var MDB = window.MDB || {};;

//Turns a regular textarea into a markdown enabled textarea.
//Note: Text will need to be displayed as Html.Raw
$.extend(MDB, {
    
    //JquerySelector: a jquery selector (a single element is expected)
    //toolboxId: (optional) jquery selector for element to which to append the toolbox to.
    //noPanel: (optional) set to true if you don't want the toolbox to have a background panel.
    markdownTextArea: function(JquerySelector, toolboxSelector, noPanel) {
        var maxHistory = 40;

        var _textarea = JquerySelector;
        _textarea.focus(),
        _history = _textarea.val() != '' ? [_textarea.val()] : [""],
        _historyIndex = 0,
        _selectedText = "";

        var _position = _textarea.val().length;
        var _selection = {
            start: 0,
            end: 0
        };

        var _buttonSeperator = '<span>&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>';
        //Toolboxbuttons
        var _buttons = {
            bold: $($('<a name="toolbox-btn" title="Bold" style="font-size:11pt;font-weight:bold;" href="javascript:void(0)"><i class="fa fa-bold"></i></a>')),
            italic: $($('<a name="toolbox-btn"  style="font-size:11pt;font-weight:bold;" href="javascript:void(0)"><i class="fa fa-italic"></i></a>')),
            link: $($('<a name="toolbox-btn"  style="font-size:11pt;font-weight:bold;" href="javascript:void(0)"><i class="fa fa-link"></i></a>')),
            h1: $($('<a name="toolbox-btn"  style="font-size:14pt;font-weight:bold;" href="javascript:void(0)">H1</a>')),
            h2: $($('<a name="toolbox-btn"  style="font-size:10pt;font-weight:bold;" href="javascript:void(0)">H2</a>')),
            ordered: $($('<a name="toolbox-btn"  style="font-size:11pt;font-weight:bold;" href="javascript:void(0)"><i class="fa fa-list-ol"></i></a>')),
            unordered: $($('<a name="toolbox-btn"  style="font-size:11pt;font-weight:bold;" href="javascript:void(0)"><i class="fa fa-list-ul"></i></a>'))
        };

        //Event handlers
        _textarea.blur(function(){
            getPositionAndSelection();
        });
        _textarea.keyup(function (e) {  
            getPositionAndSelection();
            handleKeyPress(e);
        });
        _textarea.mouseup(function () {  
            getPositionAndSelection();
        });

        setButtonHandlers();
        insertToolbox(toolboxSelector, noPanel);

        function beforeAfterText(before, after) {
            if(after == null) {
                after = before;
            }
            
            var totalLength = before.length + after.length;
            _position += totalLength;

            if(_selection.start != _selection.end) {
                _textarea.val(_textarea.val().substring(0, _selection.start) + before +
                    _textarea.val().substring(_selection.start, _selection.end) + after +
                    _textarea.val().substring(_selection.end, _textarea.val().length + totalLength));
                
                changeCusrsorPosition(_selection.end + totalLength);

            } else {
                _textarea.val(_textarea.val().substring(0, _selection.start) + before + after +
                    _textarea.val().substring(_selection.end, _textarea.val().length + totalLength));
                
                changeCusrsorPosition(_position - after.length);
            }
        }

        function underText(under) {
            var totalLength = under.length + 1;
            _position += totalLength;

            if(_selection.start != _selection.end) {
                _textarea.val(_textarea.val().substring(0, _selection.start) +
                    _textarea.val().substring(_selection.start, _selection.end) + '\n' + under +
                    _textarea.val().substring(_selection.end, _textarea.val().length + totalLength));
            } else {
                _textarea.val(_textarea.val().substring(0, _selection.start) + '\n' +  under +
                    _textarea.val().substring(_selection.end, _textarea.val().length + totalLength));
            }
            changeCusrsorPosition(_selection.end + totalLength);
        }

        function makeList(ordered) {
            var list = ordered ? '\n1. ' : '\n* '
            var totalLength = list.length;
            _position += totalLength;

            if(_selection.start != _selection.end) {
                _textarea.val(_textarea.val().substring(0, _selection.start) + list +
                    _textarea.val().substring(_selection.start, _selection.end) +
                    _textarea.val().substring(_selection.end, _textarea.val().length + totalLength));
            } else {
                _textarea.val(_textarea.val().substring(0, _selection.start) + list +
                    _textarea.val().substring(_selection.end, _textarea.val().length + totalLength));
            }
            changeCusrsorPosition(_selection.end + totalLength);
        }

        function addLink(text) {
            var linkText = '[text]',
                link = '(https://link/',
                title =  ' "title")'

            if(text != null) {
                var isLink = false;
                if(text.includes('://') || text.includes('www.')) {
                    isLink = true;
                }

                if(isLink) {
                    link = link.replace('https://link/', text);
                } else {
                    if(text != '') {
                        linkText = linkText.replace('text', text);
                        title = title.replace('title', text);
                    }
                }
            }

            var totalLength = linkText.length + link.length + title.length;
            _position += totalLength;

            _textarea.val(_textarea.val().substring(0, _selection.start) + linkText + link + title +
                _textarea.val().substring(_selection.end, _textarea.val().length + totalLength));
            changeCusrsorPosition(_position - totalLength);
            
            if(isLink) {
                changeCusrsorPosition(_position + 1);
                setSelection(_position, _position + linkText.length - 2);
            } else {
                changeCusrsorPosition(_position + linkText.length + 1);
                setSelection(_position, _position + link.length - 1);
            }
        }

        function scrollToCursor() {
            _textarea.blur();
            _textarea.focus();
        }

        function changeCusrsorPosition(position) {
            _textarea.caretTo(position);
            _position = position;
            scrollToCursor();
        }

        function setSelection(start,end) {
            _textarea[0].focus();
            _textarea[0].setSelectionRange(start, end);
            scrollToCursor();
        }

        function handleKeyPress(event) {

            if ((event.ctrlKey || event.metaKey) && event.which == 66) {
                _buttons.bold.click();
            } else if ((event.ctrlKey || event.metaKey) && event.which == 73) {
                _buttons.italic.click();
            } else if ((event.ctrlKey || event.metaKey) && event.which == 90) {
                event.preventDefault();
                undo();
            } else if ((event.ctrlKey || event.metaKey) && event.which == 89) {
                event.preventDefault();
                redo();
            }
            if(event.keyCode == 32) {
                addToHistory();
            }
        }

        function setButtonHandlers() {
            _buttons.bold.click(function(e){
                e.preventDefault();
                addToHistory();
                beforeAfterText('**');
            });
            _buttons.italic.click(function(){
                beforeAfterText('*');
                addToHistory();
            });
            _buttons.h1.click(function(){
                underText('=====');
                addToHistory();
            });
            _buttons.h2.click(function(){
                underText('-----');
                addToHistory();
            });
            _buttons.link.click(function(){
                addLink(_selectedText);
                addToHistory();
            });
            _buttons.ordered.click(function(){
                makeList(true);
                addToHistory();
            });
            _buttons.unordered.click(function(){
                addToHistory();
                makeList();
                addToHistory();
            });
        }

        function addToHistory() {
            if(_textarea.val() != _history[_historyIndex]) {
               

                if(_historyIndex != _history.length-1 ) {
                    _history.splice(_historyIndex, _history.length - _historyIndex);
                    if(_history.length == 0) {
                        _history = [""];
                    }
                }
                
                _history.push(_textarea.val());
                _historyIndex ++;
            }

            if(_history.length == maxHistory) {
                _history.splice(0,1);
                _historyIndex = maxHistory - 1;
            }
        }

        function undo() {
            if(_historyIndex != 0) {
                _historyIndex --;
                _textarea.val(_history[_historyIndex]);
            }
        }

        function redo() {
            if(_historyIndex != _history.length -1) {
                _historyIndex ++;
                _textarea.val(_history[_historyIndex]);
            }
        }

        function insertToolbox(selector, noPanel) {
            if(selector == null) {
                var div = $($('<div name="markdown-toolbox"></div>'));
                div.insertBefore(_textarea);
                selector = div;
            } 

            if(!noPanel) {
                selector.addClass('markdown-toolbox');
            }

            selector.css('width', _textarea.width() + 20); //toolbox assumes a scrollbar (+20)
            selector.css('top', _textarea.position().top);
            selector.css('left', _textarea.position().left);

            selector.append(_buttons.bold);
            selector.append(_buttonSeperator);
            selector.append(_buttons.italic);
            selector.append(_buttonSeperator);
            selector.append(_buttons.h1);
            selector.append(_buttonSeperator);
            selector.append(_buttons.h2);
            selector.append(_buttonSeperator);
            selector.append(_buttons.link);
            selector.append(_buttonSeperator);
            selector.append(_buttons.ordered);
            selector.append(_buttonSeperator);
            selector.append(_buttons.unordered);
        }

        function getPositionAndSelection() {
            _position = _textarea.prop('selectionStart');
            _selection.start = _textarea.prop('selectionStart');
            _selection.end = _textarea.prop('selectionEnd');
            _selectedText = _textarea.val().substring(_selection.start, _selection.end);
        }
    }
});